




































































































import { Vue, Component, Mixins, Watch } from "vue-property-decorator";
import { BvTableCtxObject, BvTableFieldArray } from "bootstrap-vue";
import { vip, TableType, VIPUser, VIPUserRest, db, auth, rolesList, roleLabel } from "@/loader/public";
import EntityTable from '@/component/EntityTable';
import { VIPUserRefreshTableMixin } from '@/mixins/VIPUserMixin';

@Component
export default class UsersTable extends Mixins(VIPUserRefreshTableMixin) {
	public roles: string[] = [];

	public rolesList: any[] = rolesList;

	public get canCreate(): boolean {
		return auth.user?.capabilities.create_users || false;
	}

	public get fields(): BvTableFieldArray {
		return [
			{
				key: "name",
				label: "Nom",
				sortable: true,
			},
			{
				key: "email",
				label: "Email",
				sortable: true,
			},
			{
				key: "roles",
				label: "Rôles",
			},
		];
	}

	public roleLabel = roleLabel;

	public getUsers(context: BvTableCtxObject, callback: Function) {
		VIPUserRest.list({
			page: context.currentPage,
			per_page: context.perPage,
			context: "edit",
			roles: this.roles,
			orderby: context.sortBy,
			order: context.sortDesc ? "desc" : "asc",
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}

	public viewUser(user: VIPUser) {
		this.$router.push({ name: "User", params: { id: user.id } });
	}

	public create() {
		if (!this.canCreate) {
			return;
		}

		let user = db.users.insert({
			id: db.users.list.nextNewId(),
			username: "Nouvel utilisateur",
		});
		this.viewUser(user);
	}

	@Watch("roles")
	public rolesChanged() {
		this.filterChanged();
	}
}
